<template>
  <div class="modal-wrapper">
    <div class="modal-dialog extra-large-modal" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button class="close" @click="$emit('close')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Detalhes da regra #{{ rule.id }}
            <template v-if="!rule.enabled">
              | <strong class="text-danger">Esta regra está desabilitada</strong>
            </template>
          </h4>
        </div>
        <div class="modal-body modal-body--scrollable">
          <h3>Escopo</h3>

          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th>Instituição</th>
                <th>Campus</th>
                <th>Curso</th>
                <th>Nível</th>
                <th>Modalidade</th>
                <th>Turno</th>
                <th>Semestre</th>
                <th>Origem</th>
                <th>Prioridade</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ rule.institution ? rule.institution.name : '' }}</td>
                <td>{{ rule.campus ? rule.campus.name : '' }}</td>
                <td>{{ rule.course ? rule.course.name : '' }}</td>
                <td>{{ rule.level ? rule.level.name : '' }}</td>
                <td>{{ rule.kind ? rule.kind.name : '' }}</td>
                <td>{{ rule.shift ? rule.shift.name : '' }}</td>
                <td>{{ rule.enrollmentSemester }}</td>
                <td>{{ rule.translatedOrigin }}</td>
                <td>{{ rule.priority }}</td>
              </tr>
            </tbody>
          </table>

          <div class="divider"></div>

          <h3>Recebedores</h3>

          <div class="table-responsive">
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Porcentagem do Split</th>
                  <th>Dias de transferência</th>
                  <th>Documento</th>
                  <th>Conta bancária atual</th>
                  <th>Contas desativadas</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="splitRule in externalSplitRules" :key="splitRule.id">
                  <td>{{ splitRule.recipient.name }}</td>
                  <td>{{ splitRule.percentage }}%</td>
                  <td>{{ rule.institution.transferDays.join(', ') }}</td>
                  <td>{{ splitRule.recipient.document }}</td>
                  <td class="current-bank-account">
                    <template v-if="splitRule.recipient.bankAccount">
                      <strong>Banco: </strong> {{ splitRule.recipient.bankAccount.bankCode }}
                      <strong>Tipo: </strong> {{ splitRule.recipient.bankAccount.translatedBankAccountType }}
                      <br>
                      <strong>Ag: </strong> {{ splitRule.recipient.bankAccount.agencyCode }}
                      <strong>Conta: </strong> {{ splitRule.recipient.bankAccount.number }}
                      <strong>Dígito: </strong> {{ splitRule.recipient.bankAccount.digit }}
                    </template>

                    <template v-else>
                      Não possui
                    </template>
                  </td>

                  <td class="disabled-bank-accounts">
                    <template v-if="splitRule.recipient.disabledBankAccounts.length > 0 ">
                      <div
                        v-for="disabledBankAccount in splitRule.recipient.disabledBankAccounts"
                        :key="disabledBankAccount.id"
                      >
                        <strong>Banco: </strong> {{ disabledBankAccount.bankCode }}
                        <strong>Tipo: </strong> {{ disabledBankAccount.translatedBankAccountType }}
                        <br>
                        <strong>Ag: </strong> {{ disabledBankAccount.agencyCode }}
                        <strong>Conta: </strong> {{ disabledBankAccount.number }}-{{ disabledBankAccount.digit }}
                        <br>
                        <strong>Desativada em: </strong> {{ disabledBankAccount.enabledUntil | formatDateTime }}
                        <div class="divider"></div>
                      </div>
                    </template>

                    <template v-else>
                      Não possui
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="divider"></div>

          <h3>Cobrança</h3>

          <table class="table table-striped table-bordered">
            <tbody>
              <tr>
                <td><strong>Dias disponíveis para o vencimento</strong></td>
                <td>
                  <span v-if="rule.dueDayRule && rule.dueDayRule.dueDays.length > 0">
                    {{ rule.dueDayRule.dueDays.join(', ') }}
                  </span>
                  <span v-else>
                    Nenhum
                  </span>
                </td>
              </tr>

              <tr>
                <td><strong>Aluno pode alterar dia de vencimento</strong></td>
                <td>{{ rule.dueDayRule.studentCanChangeDueDay ? 'Sim' : 'Não' }}</td>
              </tr>

              <tr>
                <td><strong>Métodos de pagamento permitidos nas mensalidades</strong></td>
                <td>
                  <span v-if="rule.paymentMethodRules.length === 0">Nenhum</span>
                  <span
                    v-for="(paymentMethodRule, index) in rule.paymentMethodRules"
                    :key="paymentMethodRule.id"
                  >
                    <template v-if="index > 0">/</template>
                    {{ paymentMethodRule.translatedPaymentMethod }}
                  </span>
                </td>
              </tr>

              <tr>
                <td><strong>Métodos de pagamento permitidos na quitação de contrato</strong></td>
                <td>
                  <span v-if="rule.contractDischargeRules.length === 0">Nenhum</span>
                  <span
                    v-for="(contractDischargeRule, index) in rule.contractDischargeRules"
                    :key="contractDischargeRule.id"
                  >
                    <template v-if="index > 0">/</template>
                    {{ contractDischargeRule.translatedPaymentMethod }}
                  </span>
                </td>
              </tr>

              <tr>
                <td><strong>Início da cobrança</strong></td>
                <td>
                  <span v-if="rule.contractCreationRule">
                    {{ rule.contractCreationRule.translatedStartRule }}
                  </span>
                  <span v-else>Indefinido</span>
                </td>
              </tr>

              <tr>
                <td><strong>Duração do contrato</strong></td>
                <td>
                  <span v-if="rule.contractCreationRule">
                    {{ rule.contractCreationRule.duration }} meses
                  </span>
                  <span v-else>Indefinido</span>
                </td>
              </tr>

              <tr>
                <td><strong>Cobrar juros e multa</strong></td>
                <td>
                  <template v-if="rule.chargesRule !== null && rule.chargesRule.applyCharges">
                    Taxa de juros: {{ rule.chargesRule.treatedInterestRate | formatPercentage }} <br>
                    Taxa de multa: {{ rule.chargesRule.treatedPenaltyRate | formatPercentage }} <br>
                    Base de cálculo: {{ rule.chargesRule.translatedChargesBasedOn }} <br>
                  </template>

                  <template v-else>
                    Não
                  </template>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>
                    Ajuste automático de mensalidades
                    <span
                      class="icon--micro glyphicon glyphicon-info-sign"
                      data-toggle="tooltip"
                      title="Permite configurar se mensalidades pagas a mais (pagamento em excesso)
                       ou a menos (pagamento insuficiente) possam ter essas diferenças transferidas
                       para outra mensalidade em aberto."
                    >
                    </span>
                  </strong>
                </td>
                <td>
                  <template v-if="rule.overpaymentBillAdjustmentRule">
                    Pagamento em excesso:
                    {{
                      formatAmountType(
                        rule.overpaymentBillAdjustmentRule.thresholdType,
                        rule.overpaymentBillAdjustmentRule.treatedThresholdValue
                      )
                    }}
                    <br>
                  </template>
                  <template v-if="rule.underpaymentBillAdjustmentRule">
                    Pagamento insuficiente:
                    {{
                      formatAmountType(
                        rule.underpaymentBillAdjustmentRule.thresholdType,
                        rule.underpaymentBillAdjustmentRule.treatedThresholdValue
                      )
                    }}
                  </template>
                  <template
                    v-if="rule.overpaymentBillAdjustmentRule === null && rule.underpaymentBillAdjustmentRule === null"
                  >
                    Não
                  </template>
                </td>
              </tr>
              <tr v-if="rule.qbIntegrationRule && rule.qbIntegrationRule.integrationDisallowed">
                <td><strong>Entrada de alunos</strong></td>
                <td>
                  Importação
                </td>
              </tr>
            </tbody>
          </table>

          <div class="row">
            <div class="col-md-6">
              <h3>Taxa de admissão</h3>

              <table class="table table-striped table-bordered" v-if="rule.admissionPaymentRule">
                <tbody>
                  <tr>
                    <td><strong>Tipo</strong></td>
                    <td>{{ rule.admissionPaymentRule.translatedAmountType }}</td>
                  </tr>

                  <tr v-if="rule.admissionPaymentRule.amountType === 'custom_amount'">
                    <td><strong>Valor</strong></td>
                    <td>
                      {{ rule.admissionPaymentRule.amountCents / 100 | formatCurrency }}
                    </td>
                  </tr>

                  <tr>
                    <td><strong>Equivale a primeira parcela</strong></td>
                    <td>{{ rule.admissionPaymentRule.equivalentToFirstBill ? 'Sim' : 'Não' }}</td>
                  </tr>
                </tbody>
              </table>

              <template v-else>
                Não possui
              </template>
            </div>

            <div class="col-md-6">
              <h3>Perda de bolsa</h3>

              <table class="table table-striped table-bordered" v-if="rule.scholarshipLosingRule">
                <tbody>
                  <tr>
                    <td><strong>Regra</strong></td>
                    <td>{{ rule.scholarshipLosingRule.translatedRule }}</td>
                  </tr>

                  <tr>
                    <td><strong>Dias de atraso</strong></td>
                    <td>
                      {{ rule.scholarshipLosingRule.lossDelay }}
                    </td>
                  </tr>

                  <tr>
                    <td><strong>Úteis/Corridos</strong></td>
                    <td>
                      {{ rule.scholarshipLosingRule.translatedLossDelayType }}
                    </td>
                  </tr>

                  <tr>
                    <td><strong>Dias de carência</strong></td>
                    <td>
                      {{ rule.scholarshipLosingRule.gracePeriod }}
                    </td>
                  </tr>
                </tbody>
              </table>

              <template v-else>
                Não possui
              </template>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <h3>Desconto de pontualidade</h3>

              <template v-if="rule.enabledAdvancedPaymentDiscountRules.length > 0">
                <table class="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th>
                        Referência
                        <span
                          class="icon--micro glyphicon glyphicon-info-sign"
                          data-toggle="tooltip"
                          title="Define se a regra conta dias a partir do início do mês ou
                          de vencimento da mensalidade."
                        >
                        </span>
                      </th>
                      <th>
                        Contagem
                        <span
                          class="icon--micro glyphicon glyphicon-info-sign"
                          data-toggle="tooltip"
                          title="Define se a regra deve considerar dias úteis ou dias corridos."
                        >
                        </span>
                      </th>
                      <th>Dias de carência</th>
                      <th>
                        Desconto
                      </th>
                      <th>Base de cálculo</th>
                      <th>
                        Retroativo
                        <span
                          class="icon--micro glyphicon glyphicon-info-sign"
                          data-toggle="tooltip"
                          title="Define se a regra será aplicada a todas as mensalidades passadas, ou seja,
                          criadas antes dessa regra ser ativada."
                        >
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="discount in rule.enabledAdvancedPaymentDiscountRules">
                      <td>{{ discount.translatedDaysRelativeTo }}</td>
                      <td>{{ discount.translatedDaysKind }}</td>
                      <td>{{ discount.days }}</td>
                      <td>
                        {{
                          formatAmountType(
                            discount.amountType,
                            discount.treatedAmountValue
                          )
                        }}
                      </td>
                      <td v-if="discount.stackDiscounts">
                        Valor com desconto
                      </td>
                      <td v-else>
                        Valor cheio
                      </td>
                      <td>{{ discount.retroactive | formatBoolean }}</td>
                    </tr>
                  </tbody>
                </table>
              </template>
              <template v-else>
                Não possui
              </template>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" @click="$emit('close')">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .current-bank-account {
    font-size: 14px;
  }

  .disabled-bank-accounts {
    font-size: 12px;
  }

  .icon--micro {
    font-size: 12px;
  }
</style>

<script>

export default {
  props: {
    rule: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.initializeTooltips();
  },
  computed: {
    externalSplitRules() {
      return this.rule.enabledSplitRules.filter(splitRule => splitRule.recipient.document !== '10542212000154');
    },
  },
  methods: {
    initializeTooltips() {
      $(() => {
        $('[data-toggle="tooltip"]').tooltip();
      });
    },
    formatAmountType(type, value) {
      let formatValue;

      if (type == null) {
        formatValue = '';
      } else if (type === 'percentage') {
        formatValue = this.$options.filters.formatPercentage(value);
      } else if (type === 'absolute') {
        formatValue = this.$options.filters.formatCurrency(value);
      }
      return formatValue;
    },
  },
};
</script>
